import axios from 'axios'

let baseURL = ''
console.log('import.meta.env', import.meta.env.MODE)
if (import.meta.env.MODE === 'development') {
  baseURL = 'https://pow-backend.piratesofweb.com/api' // for localhost
} else {
  baseURL = 'https://ecocity-backend-test.ecolarium.io/api'
}
// baseURL = 'https://ecocity-backend-test.ecolarium.io/api'
baseURL = 'https://pow-backend-mucahit.piratesofweb.com/api'

const apiClient = axios.create({
  withCredentials: true,
  baseURL: baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

apiClient.interceptors.request.use((config) => {
  const authToken = localStorage.getItem('auth-token') || null
  if (authToken) {
    config.headers['Authorization'] = `Bearer ${authToken}`
  }
  return config
})

export const signIn = async (data) => await apiClient.post('/sign-in', data)
export const meTelegram = async () => await apiClient.get('/me-telegram')
export const updatePreferences = async (data) => await apiClient.post('/me-telegram', data)

export const getConstants = async () => await apiClient.get('/constants')
export const getUserSync = async () => await apiClient.get('/sync/user')
export const getSync = async () => await apiClient.get('/sync')
export const claim = async () => await apiClient.get('/claim')
export const claimClick = async (data) => await apiClient.post('/claim/click', data)
export const claimTask = async (data) => await apiClient.post('/claim/task', data)
export const claimDailyReward = async () => await apiClient.get('/claim/daily')
export const dailySecret = async (data) => await apiClient.post('/claim/daily-secret', data)
export const deleteAccount = async () => await apiClient.delete('/me-telegram')

export const listTask = async () => await apiClient.get('/task')
export const updateCard = async (data) => await apiClient.post('/card', data)
export const updateSkin = async (data) => await apiClient.post('/skin', data)
export const buyCharacter = async (data) => await apiClient.post('/character/buy', data)
export const changeCharacterOrSkin = async (data) => await apiClient.post('/character', data)

export const listCategory = async () => await apiClient.get('/category/list')
export const listBuilds = async () => await apiClient.get('/category/builds')
export const listFriends = async () => await apiClient.get('/friend/list')
export const saveWallet = async () => await apiClient.post('/wallet')
